export default "__VITE_ASSET__c4e62406__"